/** Максимальное кол-во номенклатур на страницах /catalog */
export const PageSize = 12;
